<template>
  <div>
    <formula-input
      v-show="isOpen"
      class="relative my-2 inline-block"
      @close="active = false"
      @select="addItem"
    />
    <span
      v-show="!isOpen"
      v-tooltip="$t('COMMON.INPUT')"
      class="input-placeholder"
      @click.stop="active = true"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent, ref } from "vue";

import type { MaybeArray } from "@/models/common";
import type { CustomAttributeFormulaItem } from "@/models/customAttributes/customAttribute";

const FormulaInput = defineAsyncComponent(
  () => import("@/components/customAttributes/formula/FormulaInput.vue")
);

const emit = defineEmits<{
  (event: "select", value: MaybeArray<CustomAttributeFormulaItem>): void;
}>();

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

const active = ref(props.open);

const isOpen = computed(() => props.open || active.value);

const addItem = (item: MaybeArray<CustomAttributeFormulaItem>) => {
  emit("select", item);
  active.value = false;
};
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.input-placeholder {
  @apply h-8 cursor-pointer rounded border border-4 border-blue-300;
}
</style>
